// removed by extract-text-webpack-plugin
module.exports = {"link":"_1SzJIm4","summaryContainer":"_2c_I51U","summary":"maj4OtF","summaryOutline":"_2MbpX0u","searchSvg":"_15GN5xY","searchIcon":"_3s-8EO_","chevronSvg":"qmgjl1Z","chevronIcon":"_2v_JeCA"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/SearchBar/components/LastSearch/LastSearch.less
 ** module id = 907
 ** module chunks = 0
 **/